import React from "react"
import VerifiedIcon from "images/verified-icon.svg"
import { useComponentizedPage } from "store/contexts/componentized-page"
import { Card, Container, Image, Name, Description, Credentials } from "./styles"

const splitNameAndTitles = (fullName) => {
  const commaIndex = fullName.indexOf(",")

  if (commaIndex === -1) {
    return {
      fullName: fullName.trim(),
      titles: "",
    }
  }

  return {
    fullName: fullName.substring(0, commaIndex).trim(),
    titles: fullName.substring(commaIndex + 1).trim(),
  }
}

const PersonCard = ({
  id,
  name,
  link,
  description,
  imageUrl,
  middleElement,
  mobileHorizontal,
  imageProps,
  dataId,
  hideIdentity,
  credentials,
  ...props
}) => {
  const { isHomePage } = useComponentizedPage()
  const renderContent = () => {
    const { fullName, titles } = splitNameAndTitles(name)

    return (
      <figure>
        <Image
          {...imageProps}
          baseUrl={imageUrl}
          images={[
            {
              transforms: "c_fill,g_auto,w_542,h_542,q_90,f_auto,fl_lossy",
              screenSize: 1024,
            },
            {
              transforms: "c_fill,g_auto,w_224,h_224,q_90,f_auto,fl_lossy",
              screenSize: 768,
            },
            {
              transforms: `c_fill,g_auto,w_${mobileHorizontal ? "140" : "230"},h_${
                mobileHorizontal ? "140" : "230"
              },q_90,f_auto,fl_lossy`,
            },
          ]}
          lazy
        />
        {!hideIdentity && (
          <figcaption>
            {!isHomePage ? (
              <Name isHomePage={isHomePage}>{name}</Name>
            ) : (
              (fullName || titles) && (
                <Name isHomePage={isHomePage}>
                  {fullName} <span>{titles}</span>
                </Name>
              )
            )}
            {credentials && <Credentials isHomePage={isHomePage}>{credentials}</Credentials>}
          </figcaption>
        )}
      </figure>
    )
  }

  return (
    <Card data-exp-id={dataId} {...props}>
      <Container>
        {link ? <a href={link}>{renderContent()}</a> : renderContent()}
        {middleElement}
        {!hideIdentity && (
          <Description isHomePage={isHomePage}>
            {isHomePage && <img src={VerifiedIcon} alt="verified-icon" />}
            <p>{description}</p>
          </Description>
        )}
      </Container>
    </Card>
  )
}

export default PersonCard
